var exports = {
  "kL": "container__776P46",
  "Kk": "icon__-qQQvr",
  "R_": "heading__rNimn7",
  "VA": "subtitle__bN2dr3",
};

module.exports = exports;
